import { ExploreServiceTrailDifficulty } from '../types/ExploreServiceFilters';

// Source of truth for the difficulty filter values (order = display/chip order).
export const difficulties: ExploreServiceTrailDifficulty[] = ['easy', 'moderate', 'hard', 'strenuous'];

export const getValidDifficulties = (diffs: string[]) =>
  diffs.filter(diff => difficulties.includes(diff as ExploreServiceTrailDifficulty)) as ExploreServiceTrailDifficulty[];
